<template>
  <div id="dashboard" style="min-height: 400px;">
    <div id="dashboard" class="content">
      <div class="block block-rounded block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">用户信息</h3>
        </div>
        <div class="block-content tab-content overflow-hidden">
          <basicInfo ref="basicInfo"></basicInfo>
        </div>
      </div>
      <div id="dashboard">
        <div class="block block-rounded block-bordered">
          <div class="block-header block-header-default" style="padding: 0;">
            <ul
              class="nav nav-tabs nav-tabs-block nav-main nav-main-horizontal nav-main-hover"
              data-toggle="tabs"
              role="tablist"
            >
              <li class="nav-item" v-for="(item,index) in orderTypeList" :key="index">
                <a
                  class="nav-link"
                  :class="item.ORDER_TYPE == orderType ? 'active' + ' btabs-animated-fade-'+item.ORDER_TYPE : 'btabs-animated-fade-'+item.ORDER_TYPE "
                  href="javascript:void(0)"
                  @click="showTab('btabs-animated-fade-'+item.ORDER_TYPE,item.ORDER_TYPE)"
                >{{item.ORDER_NAME}}</a>
              </li>
            </ul>
            <button
              type="button"
              class="btn-block-option"
              data-toggle="block-option"
              data-action="fullscreen_toggle"
              style="margin-right: 1.25rem"
            >
              <i class="si si-size-fullscreen"></i>
            </button>
          </div>
          <div class="block-content tab-content overflow-hidden">
            <div
              class="tab-pane tab-pane-tab fade show active"
              id="btabs-animated-fade-1"
              role="tabpanel"
            >
              <walletBalance ref="walletBalance"></walletBalance>
            </div>
            <div class="tab-pane tab-pane-tab fade" id="btabs-animated-fade-2" role="tabpanel">
              <chargingOrder ref="chargingOrder"></chargingOrder>
            </div>
            <div class="tab-pane tab-pane-tab fade" id="btabs-animated-fade-3" role="tabpanel">
              <pilePackageOrder ref="pilePackageOrder"></pilePackageOrder>
            </div>

            <div class="tab-pane tab-pane-tab fade" id="btabs-animated-fade-4" role="tabpanel">
              <packageList ref="packageList"></packageList>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Util from "../../../Util.js";
import basicInfo from "./levelSecond/basicInfo";
import whiteInof from "./levelSecond/whiteInof";

import walletBalance from "./levelSecond/walletBalance";
import chargingOrder from "./levelSecond/chargingOrder";
import pilePackageOrder from "./levelSecond/pilePackageOrder";
import packageList from "./levelSecond/packageList";

export default {
  name: "index",
  data() {
    return {
      message: null,
      userType: [
        {
          value: 0,
          label: "普通"
        },
        {
          value: 1,
          label: "白名单"
        }
      ],
      form: {
        userId: "",
        mobilePhone: "",
        userCard: "",
        balanceMoney: "",
        groupId: "",
        startEffectiveTime: "",
        expiredTime: "",
        resetHour: "",
        limitDuration: "",
        allowOther: "",
        type: "",
        packageId: "",
        carportId: "",
        startTime: "",
        endTime: "",
        id: ""
      },
      provinceList: [],
      cityList: [],
      districtList: [],
      cellList: [],
      pro: "",
      city: "",
      dis: "",
      infoType: 1,
      infoTypeList: [
        {
          ORDER_TYPE: "1",
          ORDER_NAME: "用户信息"
        }
        // {
        //   ORDER_TYPE: "2",
        //   ORDER_NAME: "白名单信息"
        // }
      ],
      carportWhiteId: "",
      carportList: [],
      packageList: [],
      whiteMessage: {},
      hasGroupId: true,
      orderType: 1,
      orderTypeList: [
        {
          ORDER_TYPE: "1",
          ORDER_NAME: "余额明细"
        },

        {
          ORDER_TYPE: "2",
          ORDER_NAME: "充电订单"
        },
        {
          ORDER_TYPE: "3",
          ORDER_NAME: "时长包订单"
        },
        {
          ORDER_TYPE: "4",
          ORDER_NAME: "用户时长包"
        }
      ]
    };
  },
  components: {
    basicInfo,
    whiteInof,
    walletBalance,
    chargingOrder,
    pilePackageOrder,
    packageList
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    params() {
      return this.$store.state.params;
    }
  },
  watch: {
    "form.mobilePhone"(val, oldVal) {
      this.form.mobilePhone = Util.isNumber(val);
    },
    "form.userCard"(val, oldVal) {
      this.form.userCard = Util.isNumber(val);
    },
    "form.balanceMoney"(val, oldVal) {
      this.form.balanceMoney = Util.testNumberFn(val, "inputChangeTwoDecimal");
    }
  },
  mounted() {
    if (this.$route.params.type) {
      this.$store.commit("setParam", {
        params: this.$route.params
      });
    }
    console.log(this.$route.params.white);
    if (!this.$route.params.white) {
      this.showTab("btabs-animated-fade-4", 4);
    }
    console.log(this.params);
    setTimeout(() => {
      Dashmix.helpers(["flatpickr", "datepicker"]);
    }, 1000);
    this.getUser(this.$route.params.id);
    this.getProvince();
    this.searchCarport();
  },
  methods: {
    showInof(el, type) {
      $(`.${el}`).tab("show");
      for (let i of $(`.tab-pane-info`)) {
        i.className = "tab-pane-info tab-pane fade";
      }
      $(`#${el}`).tab("show");
      this.infoType = type;
      if (type == 1) {
        this.$refs.basicInfo.getUser(this.$route.params.id);
        if (this.params.type == "pile" || this.params.type == "white") {
          this.$refs.basicInfo.getChargeWhite(this.$route.params.id);
          this.$refs.basicInfo.getProvince();
        } else {
          this.getCarportWhite(this.carportWhiteId);
          this.$refs.basicInfo.searchCarport();
        }
      } else if (type == 2) {
        this.$refs.whiteInof.getUser(this.$route.params.id);
        if (this.params.type == "pile" || this.params.type == "white") {
          this.$refs.whiteInof.getChargeWhite(this.$route.params.id);
          this.$refs.whiteInof.getProvince();
        } else {
          this.getCarportWhite(this.carportWhiteId);
          this.$refs.whiteInof.searchCarport();
        }
      }
    },
    showTab(el, type) {
      $(`.${el}`).tab("show");
      for (let i of $(`.tab-pane-tab`)) {
        i.className = "tab-pane-tab tab-pane fade";
      }
      $(`#${el}`).tab("show");
      this.orderType = type;
      if (type == 1) {
        this.$refs.walletBalance.getList();
      } else if (type == 2) {
        this.$refs.chargingOrder.getList();
      } else if (type == 3) {
        this.$refs.pilePackageOrder.getList();
      } else if (type == 4) {
        this.$refs.packageList.getList();
      }
    },
    changeGroupId() {
      if (this.hasGroupId) return;
      this.$http
        .get(
          `${Util.searchURL}/FlatComplex/GetWhitePackage/${this.form.groupId}`
        )
        .then(
          res => {
            if (res.data.code === 200) {
              this.packageList = res.data.data;
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    searchCarport() {
      this.$http.get(`${Util.searchURL}/Carport/ListByAll?key=`).then(
        res => {
          if (res.data.code === 200) {
            this.carportList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    getCarportWhite(val) {
      this.$http.get(`${Util.searchURL}/Carport/GetWhiteList/${val}`).then(
        res => {
          if (res.data.code === 200) {
            let d = res.data.data;
            this.whiteMessage = d;
            if (d) {
              this.form.startEffectiveTime = d.START_TIME;
              this.form.expiredTime = d.END_TIME;
              this.form.carportId = d.CARPORT_ID;
              this.form.id = d.ID;
            }

            this.$forceUpdate();
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    getChargeWhite(val) {
      this.$http.get(`${Util.searchURL}/FlatComplex/GetWhite/${val}`).then(
        res => {
          if (res.data.code === 200) {
            this.packageList = res.data.data.package;
            let d = res.data.data.data;
            this.whiteMessage = d;
            if (d) {
              this.form.packageId = d.PACKAGE_ID ? d.PACKAGE_ID : "";
              this.form.limitDuration = d.LIMIT_DURATION;
              this.form.resetHour = d.RESET_HOUR;
              this.form.startEffectiveTime = d.START_EFFECTIVE_TIME;
              this.form.expiredTime = d.EXPIRED_TIME;
            }
            Util.displayAreaCell(this.form.groupId, this, true, true);
            this.form = Object.assign({}, this.form);
            this.$forceUpdate();
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    delWhiteUser() {
      let url, d;
      if (this.params.type == "pile" || this.params.type == "white") {
        if (this.message.USER_WHITE_TYPE == "0") return;
        url = `${Util.operateURL}/cell/deleteUser`;
        d = {
          userId: this.form.userId,
          groupId: this.form.groupId
        };
      }
      if (this.params.type == "carport") {
        if (this.message.CARPORT_WHITE_TYPE == "0") return;
        url = `${Util.operateURL}/white/deleteWhiteModel`;
        d = { id: this.carportWhiteId };
      }
      swal("确定移出白名单用户？", {
        buttons: {
          cancel: {
            text: "取消",
            className: "btn btn-sm btn-light btn-sm-h",
            visible: true
          },
          defeat: {
            text: "确定",
            className: "btn btn-sm btn-primary btn-sm-h"
          }
        }
      }).then(value => {
        switch (value) {
          case "defeat":
            this.$http.post(url, d).then(res => {
              if (res.data.code === 200) {
                Util.message("succ", res.data.desc);
                this.getUser(this.$route.params.id);
              } else {
                Util.message("err", res.data.desc);
              }
            });
            break;
        }
      });
    },
    submit(val) {
      let url = "";
      if (val) {
        if (this.params.type == "pile" || this.params.type == "white") {
          url = `${Util.operateURL}/timeLen/buyChargeUserPackage`;
        } else if (this.params.type == "carport") {
          this.form.startTime = this.form.startEffectiveTime;
          this.form.endTime = this.form.expiredTime;
          url = `${Util.operateURL}/white/updateWhiteModel`;
        }
      } else {
        url = `${Util.operateURL}/user/updateUserInfo`;
      }
      this.$http.post(url, this.form).then(
        res => {
          if (res.data.code === 200) {
            Util.message("succ", res.data.desc);
            this.getUser(this.$route.params.id);
          } else {
            Util.message("err", res.data.desc);
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    getUser(val) {
      this.$http.get(`${Util.searchURL}/User/Info/${val}`).then(
        res => {
          if (res.data.code === 200) {
            let d = res.data.data;
            this.message = d;
            this.carportWhiteId = d.CARPORT_WHITE_ID;
            this.form = {
              userId: d.USER_ID,
              mobilePhone: d.MOBILE_PHONE,
              userCard: d.CARD_NO,
              balanceMoney: "",
              groupId: d.GROUP_ID
            };
            if (!d.GROUP_ID) {
              this.hasGroupId = false;
            }
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    getProvince() {
      this.$http.get(`${Util.searchURL}/Province/ListAll`).then(
        res => {
          if (res.data.code === 200) {
            this.provinceList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    provinceSel() {
      this.$http.get(`${Util.searchURL}/City/ListByProvince/${this.pro}`).then(
        res => {
          if (res.data.code === 200) {
            this.cityList = res.data.data;
            this.city = "";
            this.dis = "";
            this.form.groupId = "";
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    citySel() {
      this.$http.get(`${Util.searchURL}/District/ListByCity/${this.city}`).then(
        res => {
          if (res.data.code === 200) {
            this.districtList = res.data.data;
            this.dis = "";
            this.form.groupId = "";
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    disSel() {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/ListByDistrict/${this.dis}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.cellList = res.data.data;
              this.form.groupId = "";
            }
          },
          err => {
            console.log(err);
          }
        );
    }
  }
};
</script>

